// Date range picker chips + custom range popover.
import { useState } from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";

const PRESETS = [
  { id: "today", label: "Azi" },
  { id: "yesterday", label: "Ieri" },
  { id: "7d", label: "7 zile" },
  { id: "30d", label: "30 zile" },
  { id: "mtd", label: "Luna curentă" },
  { id: "90d", label: "90 zile" },
  { id: "ytd", label: "YTD" },
];

export default function DateRangeFilter({ range, onChange }) {
  const [open, setOpen] = useState(false);
  const [from, setFrom] = useState(range?.from || "");
  const [to, setTo] = useState(range?.to || "");
  const active = range?.range || "30d";
  return (
    <div className="flex items-center gap-1 flex-wrap">
      {PRESETS.map((p) => (
        <button
          key={p.id}
          data-testid={`analytics-range-${p.id}`}
          onClick={() => onChange({ range: p.id })}
          className={`text-[12px] px-3 py-1.5 rounded-full transition-colors ${
            active === p.id && !range?.from
              ? "bg-primary text-primary-foreground"
              : "bg-secondary/50 text-muted-foreground hover:bg-secondary"
          }`}
        >
          {p.label}
        </button>
      ))}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            data-testid="analytics-range-custom"
            className={`text-[12px] px-3 py-1.5 rounded-full flex items-center gap-1.5 transition-colors ${
              range?.from
                ? "bg-primary text-primary-foreground"
                : "bg-secondary/50 text-muted-foreground hover:bg-secondary"
            }`}
          >
            <CalendarIcon className="h-3 w-3" />
            {range?.from ? `${range.from} → ${range.to}` : "Interval custom"}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-72 p-3">
          <div className="space-y-2">
            <div>
              <label className="text-[11px] text-muted-foreground">De la</label>
              <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
            </div>
            <div>
              <label className="text-[11px] text-muted-foreground">Până la</label>
              <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
            </div>
            <div className="flex gap-2 pt-2">
              <Button
                size="sm"
                className="flex-1"
                disabled={!from || !to}
                onClick={() => {
                  onChange({ from, to });
                  setOpen(false);
                }}
                data-testid="analytics-range-apply"
              >
                Aplică
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => { setFrom(""); setTo(""); onChange({ range: "30d" }); setOpen(false); }}
              >
                <X className="h-3.5 w-3.5" />
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
